module.exports = __webpack_public_path__ + "img/pin-shadow.ad8294cb.png";